// extracted by mini-css-extract-plugin
export default {"fs":"beeff82746 a30ea44e65"};